<template>
    <div class="wb-room-confirm-anchor"
         :style="{'bottom': '10%', 'left': 'calc(50% - 20px)'}"
    >
        <NavbarGreenButton :text="text" v-on:click="storeUI.switchMode()"/>
    </div>
</template>

<script>
import NavbarGreenButton from '@/UI/Components/ComponentsNavbar/NavbarGreenButton.vue';
import { useUIOnlyStore } from '@/Store/storeUI';

export default {
    name: 'OverlayRoomConfirm',
    props: [
        'top',
        'left',
        'text',
    ],
    components: {
        NavbarGreenButton,
    },
    setup() {
        const storeUI = useUIOnlyStore();
        return {
            storeUI,
        };
    },
};
</script>

<style scoped lang="scss">
@import "CSS/common.scss";

.wb-room-confirm-anchor {
    @include wb-c-flex-center;
    height: 0;
    width: 0;
    position: absolute;
    z-index: 200;
}
</style>